import { Divider } from '@mui/joy';
import { SyntheticEvent } from 'react';
import { UseFormReset } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { vendorService } from 'contacts/services';
import { IVendor } from 'contacts/types';
import { Form, FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';

import { CorporatePartAssignVendorFormData } from './types';

interface IProps {
  isOpen: boolean;
  onSubmit: (
    reset?: UseFormReset<CorporatePartAssignVendorFormData>
  ) => (data: CorporatePartAssignVendorFormData) => void;
  onClose: (
    reset?: UseFormReset<CorporatePartAssignVendorFormData>,
    closeSelection?: boolean
  ) => void;
  disabled?: boolean;
  interactive?: boolean;
  level?: number;
}

export const LegacyCorporatePartAssignVendorFormFields = ({
  isOpen,
  onSubmit,
  onClose,
  disabled = false,
  interactive,
  level,
}: IProps) => {
  const { t } = useTranslation();

  const { setValue } = useFormContext();

  const onChangeVendor = (vendor: IVendor) => {
    setValue('vendorName', vendor?.vendorName);
    setValue('vendorId', vendor?.vendorId);
  };

  return (
    <Form
      title={t('titleAssignVendor')}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      disabledSubmit={disabled}
      interactive={interactive}
      level={level}
    >
      <FormField
        name="vendor"
        type={InputType.AUTOCOMPLETE}
        inputProps={{
          label: t('labelVendor'),
          placeholder: t('placeholderVendor'),
          optionKey: 'contactGroupId',
          getKey: (option: IVendor) => option.contactGroupId,
          getOptions: vendorService.getManyAutocomplete,
          getLabel: (option: IVendor) => `${option?.vendorName} (${option?.vendorId})`,
          onChange: (_: SyntheticEvent, option: IVendor) => onChangeVendor(option),
          requestPayload: {
            viewBy: { alternateVersionEnabled: 0 },
          },
          disabled,
        }}
      />

      <Divider />

      <FormField
        name="vendorName"
        type={InputType.TEXT_INPUT}
        inputProps={{ label: t('labelVendorName'), placeholder: t('labelVendorName'), disabled }}
      />

      <FormField
        name="vendorId"
        type={InputType.TEXT_INPUT}
        inputProps={{
          label: t('labelVendorId'),
          placeholder: t('labelVendorId'),
          disabled,
        }}
      />
    </Form>
  );
};
